export default "__VITE_ASSET__856522cf__"